import { CONFIRM_BOOKING_GOLF, CONFIRM_BOOKING_GOLF_SUCCESS, CONFIRM_BOOKING_GOLF_ERROR, CONFIRM_BOOKING_GOLF_EMPTY } from '../../../actionType.js';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const ConfirmBookingGolf = (state = initialState, action) => {
  switch (action.type) {
    case CONFIRM_BOOKING_GOLF:
      state = {
        ...state,
        data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case CONFIRM_BOOKING_GOLF_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case CONFIRM_BOOKING_GOLF_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: null,
      };
      break;

    case CONFIRM_BOOKING_GOLF_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default ConfirmBookingGolf;
